<template>
  <div v-if="propBreadcrumbs.length > 0" class="c-breadcrumbs flex flex-wrap items-center space-x-2">
    <router-link to="/" class="c-breadcrumbs__home a-static flex items-center shrink text-basic-text truncate">
      <c-icon icon="home" size="compact" class="c-breadcrumbs__icon block after:hover:bg-primary-medium"/>
    </router-link>
    <template v-for="item in propBreadcrumbs" :key="item.value">
      <c-icon color="medium" icon="chevron-right" size="compact" class="c-breadcrumbs__arrow block"/>
      <span
        v-if="item.isCategory"
        class="block shrink font-subtitle2 truncate text-basic-text"
      >
        {{ item.text }}
      </span>
      <router-link
        v-else
        :to="item.value"
        class="a-static block shrink font-subtitle2 truncate hover:text-primary-medium"
      >
        {{ item.text }}
      </router-link>
    </template>
  </div>
</template>

<script>
import CIcon from '@/components/CIcon'
import { props } from './props'
import { computed } from 'vue'
import { useStore } from 'vuex'
import useList from '@/uses/useList'

export default {
  name: 'CBreadcrumbs',
  components: { CIcon },
  props,
  setup (props) {
    const store = useStore()
    const propList = useList(props)
    const propBreadcrumbs = computed(() => {
      return props.list ? propList.value : (store.getters.getBreadcrumbs || [])
    })
    return {
      propBreadcrumbs
    }
  }
}
</script>

<style lang="scss">
html[dir="rtl"] .c-breadcrumbs .c-icon:not(.icon-home) {
  transform: rotate(180deg);
}
</style>
